import styled from 'styled-components'
import media from 'styles/media'

const Wrapper = styled.div`
  padding-top: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const SectionWrapper = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (${media.screenSmMiniMax}) {
    padding-left: 8px;
    padding-right: 8px;
  }
`

const TabsWrapper = styled.div`
  width: 100%;
  padding-top: 12px;
`

const InstructionsWrapper = styled.div`
  z-index: 3;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  position: fixed;
  bottom: 8px;
  padding-left: 16px;
  padding-right: 16px;
`

const CouponDetailWrapper = styled(SectionWrapper)`
  padding-top: 32px;
  @media (${media.screenSmMiniMax}) {
    padding-top: 16px;
  }
`

export { Wrapper, SectionWrapper, TabsWrapper, InstructionsWrapper, CouponDetailWrapper }
